import { render, staticRenderFns } from "./BindAuthCode.vue?vue&type=template&id=3d37c741&scoped=true&"
import script from "./BindAuthCode.vue?vue&type=script&lang=js&"
export * from "./BindAuthCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37c741",
  null
  
)

export default component.exports